/* eslint-disable react/jsx-props-no-spreading */
import { ConfigProvider, Typography } from 'antd';
import { TextProps } from 'antd/lib/typography/Text';
import React from 'react';

const { Text: AntText } = Typography;

interface Props extends TextProps {
  color?: string;
}

const Text = ({ color, ...rest }: Props) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorText: color ?? '#1B1E21',
        },
      }}>
      <AntText {...rest} />
    </ConfigProvider>
  );
};

export default Text;
